import React, { type CSSProperties } from 'react'
import { ParagraphStyled } from './Paragraph.styles'

export interface ParagraphProps {
  children: React.ReactNode
  align?: CSSProperties['textAlign']
  className?: string
  isDesktop?: boolean
}

export function Paragraph({
  align = 'left',
  children,
  className,
  isDesktop,
  ...options
}: ParagraphProps) {
  return (
    <ParagraphStyled align={align} className={className} isDesktop={isDesktop} {...options}>
      {children}
    </ParagraphStyled>
  )
}
